// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.filters_CVeGJ {
  padding : var( --size-padLarge, 16px );
}

.layout_k2D1n {
  display : grid;
  grid-template-columns: 1fr 400px;
}

.editor_gdRnh {
  border-left : 4px solid var( --color-base100, #eeeeee );
}

.padding_AgJL0 {
  padding : var( --size-padMedium, 8px ) 0;
}`, "",{"version":3,"sources":["webpack://./src/screens/role/RoleScreen.css"],"names":[],"mappings":";AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["\n.filters {\n  padding : var( --size-padLarge, 16px );\n}\n\n.layout {\n  display : grid;\n  grid-template-columns: 1fr 400px;\n}\n\n.editor {\n  border-left : 4px solid var( --color-base100, #eeeeee );\n}\n\n.padding {\n  padding : var( --size-padMedium, 8px ) 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": `filters_CVeGJ`,
	"layout": `layout_k2D1n`,
	"editor": `editor_gdRnh`,
	"padding": `padding_AgJL0`
};
export default ___CSS_LOADER_EXPORT___;
